export const ListQueryKey = 'activityGqRecords';
export const DetailQueryKey = 'activityRecommendRecord';
export const Urls = {
  selectUrl: '/GqRecord/list',
  updateUrl: '/GqRecord/update',
  deleteUrl: '/GqRecord/delete',
  createUrl: '/GqRecord/create',
  detailUrl: '/GqRecord/info'
};